// Pure Stripe-error/status -> user-facing-message classification, extracted
// VERBATIM from handleSubmit's two switch statements.

// stripeError from stripe.confirmPayment()'s { error } result.
export const classifyStripeConfirmError = (stripeError) => {
  let errorMessage = stripeError.message;

  // Provide more user-friendly messages for common failure codes
  if (stripeError.code) {
    switch (stripeError.code) {
      case 'card_declined':
        errorMessage = 'Your card was declined. Please try a different payment method or contact your bank.';
        break;
      case 'insufficient_funds':
        errorMessage = 'Your card has insufficient funds. Please try a different payment method.';
        break;
      case 'expired_card':
        errorMessage = 'Your card has expired. Please use a different card.';
        break;
      case 'incorrect_cvc':
        errorMessage = 'Your card\'s security code is incorrect. Please check and try again.';
        break;
      case 'incorrect_number':
        errorMessage = 'Your card number is incorrect. Please check and try again.';
        break;
      case 'processing_error':
        errorMessage = 'An error occurred while processing your payment. Please try again.';
        break;
      case 'generic_decline':
        errorMessage = 'Your card was declined. Please try a different payment method.';
        break;
      default:
        // Use Stripe's error message if no specific handling
        errorMessage = stripeError.message || 'Payment failed. Please try again.';
    }
  }

  return errorMessage;
};

// paymentIntent.status === 'failed' -> paymentIntent.last_payment_error.
export const classifyPaymentIntentFailureMessage = (paymentIntent) => {
  const failureMessage = paymentIntent.last_payment_error?.message || 'Your payment was declined.';
  const failureCode = paymentIntent.last_payment_error?.code;

  let userFriendlyMessage = failureMessage;
  if (failureCode) {
    switch (failureCode) {
      case 'card_declined':
        userFriendlyMessage = 'Your card was declined. Please try a different payment method or contact your bank.';
        break;
      case 'insufficient_funds':
        userFriendlyMessage = 'Your card has insufficient funds. Please try a different payment method.';
        break;
      case 'expired_card':
        userFriendlyMessage = 'Your card has expired. Please use a different card.';
        break;
      case 'incorrect_cvc':
        userFriendlyMessage = 'Your card\'s security code is incorrect. Please check and try again.';
        break;
      case 'incorrect_number':
        userFriendlyMessage = 'Your card number is incorrect. Please check and try again.';
        break;
      case 'generic_decline':
        userFriendlyMessage = 'Your card was declined. Please try a different payment method.';
        break;
      default:
        // Use the failure message from Stripe if no specific handling
        break;
    }
  }

  return { userFriendlyMessage, failureCode, failureMessage };
};
